import {action, makeAutoObservable, runInAction} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import { SalePriceService } from "../../../service/SalePriceService";

class DeliveryTimeStore {

    public loading: boolean;
    public commonStore: CommonStore;
    public articleId: string;
    public elements: number[];
    public selectedDeliveryTime?: number;
    public isSearchDialogOpen: boolean;

    constructor(commonStore: CommonStore, initialLoadAmount: number, articleId: string, selectedDeliveryTime?: number) {
        this.loading = false;
        this.commonStore = commonStore;
        this.articleId = articleId;
        this.elements = [];
        this.selectedDeliveryTime = selectedDeliveryTime;
        this.isSearchDialogOpen = false;
        makeAutoObservable(this);
    }

    @action
    public async search(): Promise<void> {
        this.loading = true;
        const response = await SalePriceService.getAgencySalePrice();
        if (response.success) {
            runInAction(() => {
                this.elements = response.data?.articleSalePrices
                    .filter(el => el.articleId === this.articleId)
                    .map(el => el.deliveryTimeDays) || [];
            })
        }
        this.commonStore.processErrors(response);
        this.loading = false;
    }

    @action
    public toggleSearchDialog(value?: boolean) {
        value = (value === undefined) ? !this.isSearchDialogOpen : value;
        if (value) {
            this.search();
        }
        this.isSearchDialogOpen = value;
    }

    get isEmpty(): boolean {
        return this.elements.length === 0;
    }

    @action
    public setSelectedDeliveryTime(deliveryTime?: number) {
        this.selectedDeliveryTime = deliveryTime;
        this.isSearchDialogOpen = false;
    }

}

export default DeliveryTimeStore;